export const CLASSNAME_PREFIX = 'fade';

export const MODAL_CONTAINER_ID = 'taskComplete';
